import React from "react";
import "./style.css";
import {getNotRecommendedDietaryPreferences} from "../../../../../utils/common";
import Lottie from "react-lottie";
import animationData from "../../../../../static/json/questionnaire/weight-loss/DietaryPreference.json";

import { Image } from "../../../../../components/Image";

export const NotRecommended = ({data}) => {
  const notRecommendedItems = getNotRecommendedDietaryPreferences(data?.healthConcerns);
  
  if (notRecommendedItems.length === 0) {
    return null;
  }

  return (
    <div className="not-recommended" data-model-id="16761:2158">
      <div className="not-recommended-list">
        <div className="not-recommended-text">
          <div className="text-wrapper">Not Recommended</div>
          <p className="div">Based on the information you provided.</p>
        </div>
      </div>
      
      {notRecommendedItems.map((item, index) => (
        <div className="list" key={index}>
          <div className="text-wrapper-2">{item}</div>
          <Image src="/static/image/questionnaire/fasting/dietaryPreference/icon-1.png" alt="Icon" className="icon" />
        </div>
      ))}

      <div className="img">
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice'
            }
          }}
          height={92}
          width={91}
          isStopped={false}
          isPaused={false} 
        />
      </div>
    </div>
  );
};
